import { Link, useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { ChevronRight, ShoppingCart, Truck, Award, Shirt } from "lucide-react"
import { useDispatch } from 'react-redux';
import { addToCart } from '../redux/actions/cartActions';
import BASE_URL from '../utils/apiConfig';
import { toast } from 'react-toastify';
import { Swiper, SwiperSlide } from 'swiper/react';
import { useState } from 'react';
import { Pagination } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/pagination';
import { Button } from "../components/ui/button"
import { Badge } from "../components/ui/badge"
import EnhancedLegacyCard from "../components/home/EnhancedLegacyCard"
import TestimonialCard from "../components/home/TestimonialCard"
import products from "../data/homeProductsData.js";
import image from "../assets/images/actual_arg.webp"
import homeRealmadrid from "../assets/images/home_realmadrid.jpg"
import categoryIconos from "../assets/images/marado.jpg"
import categoryBalondeoro from "../assets/images/balondeoro2.jpg"
import categoryChampions from "../assets/images/champions2.webp"
import categoryWorldcup from "../assets/images/worldcup2.jpg"

const categoriesData = [
  {
    category: 'jugadores-iconos',
    image: categoryIconos, // Tu import existente
    title: 'Íconos',
    description: 'Jugadores que marcaron épocas. Leyendas eternas del fútbol mundial.',
    itemCount: 20,
    trending: false
  },
  {
    category: 'balon-oro',
    image: categoryBalondeoro, // Tu import existente
    title: 'Balón de oro',
    description: 'Reconocimiento al mejor de cada año. Ediciones únicas y especiales.',
    itemCount: 68,
    trending: false
  },
  {
    category: 'champions',
    image: categoryChampions, // Tu import existente
    title: 'Champions',
    description: 'Donde se forjan las leyendas. Los reyes de Europa.',
    itemCount: 23,
    trending: false
  },
  {
    category: 'mundial',
    image: categoryWorldcup, // Tu import existente
    title: 'Campeones del mundo',
    description: 'La cima del fútbol. Selecciones ganadoras de la Copa del Mundo.',
    itemCount: 8,
    trending: false
  }
]

export default function HomePage2() {
  const navigate = useNavigate();
  const discount = useSelector(state => state.discount.percentage);
  const dispatch = useDispatch();

  const handleAddToCart = async (product, selectedVariant) => {
    try {
      const currentId = Array.isArray(product.id) ? product.id[selectedVariant] : product.id;
      
      // Fetchear los datos reales del producto
      const response = await fetch(`${BASE_URL}/products/${currentId}`);
      if (!response.ok) {
        throw new Error('Error al cargar el producto');
      }
      
      const realProduct = await response.json();
      const mainVariant = realProduct.ProductVariants[0];
      
      const cartItem = {
        id: mainVariant.id,
        productId: realProduct.id,
        name: realProduct.name,
        description: realProduct.description,
        image_url: realProduct.image_url,
        price: mainVariant.price,
        quantity: 1,
        sku: mainVariant.sku,
        selectedOptions: null,
        customText: null,
      };
      
      dispatch(addToCart(cartItem));
      toast.success('¡Agregado al carrito!');
    } catch (error) {
      console.error('Error al agregar al carrito:', error);
      toast.error('Error al agregar el producto al carrito');
    }
  };

  const handleCategoryClick = (category) => {
    // Aquí va tu lógica de navegación
    console.log(`Navegando a: ${category}`)
    // Ejemplo con router:
    // navigate(`/categoria/${category}`)
    // o window.location.href = `/categoria/${category}`
  }

  return (
    <div className="flex min-h-screen flex-col">
      {/* Navbar */}
      {/* <header className="sticky top-0 z-50 w-full border-b bg-background/95 backdrop-blur supports-[backdrop-filter]:bg-background/60">
        <div className="container flex h-16 items-center justify-between">
          <Link href="/" className="flex items-center gap-2">
            <img
              src={image2}
              alt="Archivo Deportivo Logo"
              width={40}
              height={40}
              className="rounded-md"
            />
            <span className="text-xl font-semibold tracking-tight">Archivo Deportivo</span>
          </Link>
          <nav className="hidden md:flex gap-6">
            <Link href="#" className="text-sm font-medium transition-colors hover:text-primary">
              Inicio
            </Link>
            <Link href="#" className="text-sm font-medium text-muted-foreground transition-colors hover:text-primary">
              Iconos
            </Link>
             <Link href="#" className="text-sm font-medium text-muted-foreground transition-colors hover:text-primary">
              Ballon d'or
            </Link>
            <Link href="#" className="text-sm font-medium text-muted-foreground transition-colors hover:text-primary">
              Champions
            </Link>
            <Link href="#" className="text-sm font-medium text-muted-foreground transition-colors hover:text-primary">
              Mundial
            </Link>
          </nav>
          <div className="flex items-center gap-4">
            <Button variant="outline" size="icon" className="relative">
              <InfoIcon className="h-5 w-5" />
            </Button>
            <Button variant="outline" size="icon" className="relative">
              <ShoppingCart className="h-5 w-5" />
              <span className="absolute -top-1 -right-1 flex h-5 w-5 items-center justify-center rounded-full bg-primary text-xs text-primary-foreground">
                0
              </span>
            </Button>
            <Button className="hidden md:flex">Explorar Catálogo</Button>
          </div>
        </div>
      </header> */}

      <section className="bg-[#606c38] text-white py-3">
        <div className="container mx-auto px-4">
          <div className="flex flex-col sm:flex-row justify-center items-center gap-4 sm:gap-8 text-center">
            <div className="flex items-center gap-2">
              <span className="bg-[#fefae0] text-[#606c38] font-semibold px-2 py-1 rounded text-sm">
                20% OFF
              </span>
              <span className="text-sm font-medium">en todas las camisetas</span>
            </div>
            
            <div className="w-px h-4 bg-white/40 hidden sm:block"></div>
            
            <div className="flex items-center gap-2">
              <span className="bg-[#fefae0] text-[#606c38] font-semibold px-2 py-1 rounded text-sm">
                ENVÍO GRATIS
              </span>
              <span className="text-sm font-medium">desde $150.000</span>
            </div>
          </div>
        </div>
      </section>

      <main className="flex-1">
        {/* Hero Section */}
        <section className="relative overflow-hidden">
          <div className="absolute inset-0 z-0">
            <img
              src={image}
              alt="Camiseta icónica"
              fill
              className="object-cover opacity-30"
              priority
            />
            <div className="absolute inset-0 bg-gradient-to-r from-background via-background/95 to-background/80" />
          </div>
          <div className="container relative z-10 py-24 md:py-32">
            <div className="grid gap-8 md:grid-cols-2 md:gap-12 items-center">
              <div className="space-y-6">
                <Badge className="px-3 py-1 text-sm bg-[#606c38] hover:bg-[#606c38]/80">
                  El legado del deporte, en tus manos
                </Badge>
                <h1 className="text-4xl font-bold tracking-tighter sm:text-5xl md:text-6xl">
                  Revive la gloria. <br />
                  <span className="text-[#606c38]">Viste el legado.</span>
                </h1>
                <p className="max-w-[600px] text-muted-foreground md:text-xl">
                  Camisetas importadas de calidad original, personalizables con dorsal y parches
                </p>
                <p className="max-w-[600px] text-muted-foreground md:text-xl">
                  Más de 8000 modelos únicos, actuales y retro, que no encontrarás en ningún otro lugar
                </p>
                <div className="flex flex-col sm:flex-row gap-4">
                  <Button size="lg" className="bg-[#606c38] hover:bg-[#606c38]/90" 
                    onClick={() => {
                    navigate(`/products`)
                    window.scrollTo(0, 0)
                  }}>
                    Explorá el catálogo
                    <ChevronRight className="ml-2 h-4 w-4" />
                  </Button>
                  <Button size="lg" variant="outline" onClick={() => {
                    const target = document.getElementById('camisetasDestacadas');
                    if (target) target.scrollIntoView({ behavior: 'smooth' });
                  }}>
                    Camisetas Destacadas
                  </Button>
                </div>
              </div>
              <div className="relative rounded-lg overflow-hidden shadow-2xl transform transition-transform hover:scale-[1.02] duration-500">
                <img
                  src={homeRealmadrid}
                  alt="Camiseta Argentina Campeón del Mundo"
                  fill
                  className="object-cover"
                />
              </div>
            </div>
          </div>
        </section>

        {/* Productos Destacados */}
        <section id="camisetasDestacadas" className="py-12 bg-gradient-to-br from-[#fefae0]/40 via-white to-[#fefae0]/20">
          <div className="container">
            <div className="flex flex-col lg:flex-row justify-between items-start lg:items-center mb-16 gap-6">
              <div className="max-w-2xl">
                <h2 className="text-4xl lg:text-5xl font-light tracking-tight text-gray-900 mb-4">Camisetas Destacadas</h2>
                <p className="text-lg text-gray-600 leading-relaxed">
                  Modelos exclusivos que cuentan historias inolvidables del fútbol mundial. 
                </p>
                <p className="text-lg text-gray-600 leading-relaxed">
                  Cada pieza es una obra de arte deportiva.
                </p>
              </div>
              <Button variant="outline" className="border-[#606c38] text-[#606c38] hover:bg-[#606c38] hover:text-white"
                onClick={() => {
                  navigate(`/products`)
                  window.scrollTo(0, 0)
                }}>
                Ver Colección Completa
              </Button>
            </div>

            <Swiper modules={[Pagination]} pagination={{ clickable: true, }} className="!pb-12" spaceBetween={24} slidesPerView={1} 
            breakpoints={{ 768: { slidesPerView: 2, }, 1024: { slidesPerView: 4, }, }} >

              {products.map((product) => {
                const ProductCard = () => {
                  const [selectedVariant, setSelectedVariant] = useState(0);
                  const pruductPrice = (Array.isArray(product.price) ? product.price[selectedVariant] : product.price)
                  const discountedPrice = pruductPrice * (1 - discount / 100);
                  
                  return (
                    <div className="group relative h-full">
                      <div className="bg-white rounded-2xl overflow-hidden shadow-md hover:shadow-xl transition-all duration-500 border border-gray-100 h-full flex flex-col">
                        {/* Image Container */}
                        <div className="relative overflow-hidden">
                          <img 
                            src={Array.isArray(product.img) ? product.img[selectedVariant] : product.img} alt={product.name} 
                            className="w-full h-72 object-contain transition-transform duration-500 group-hover:scale-105" 
                          />
                        </div>

                        {/* Content */}
                        <div className="p-6 flex flex-col flex-1 justify-between">
                          {/* Header */}
                          <div>
                            <div className="flex items-center justify-between mb-3">
                              <h3 className="font-semibold text-lg text-gray-900">{product.name}</h3>
                              <Badge variant="outline" className="text-xs border-[#606c38] text-[#606c38]">
                                {Array.isArray(product.variants) ? product.variants[selectedVariant] : product.variants}
                              </Badge>
                            </div>
                            <p className="text-sm text-gray-600 mb-4 leading-relaxed">{product.description}</p>
                          </div>

                          {/* Price */}
                          <div className="flex items-center gap-2 mb-4">
                            <span className="text-xl font-bold text-[#606c38]">${discountedPrice.toLocaleString()}</span>
                            {pruductPrice && (
                              <span className="text-sm text-gray-400 line-through">
                                ${pruductPrice.toLocaleString()}
                              </span>
                            )}
                          </div>

                          {/* Variants */}
                          <div className="mb-4">
                            <p className="text-xs font-medium text-gray-700 mb-2 flex items-center gap-1">
                              <Shirt className="h-3 w-3" />
                              Variantes:
                            </p>
                            <div className="flex gap-1 flex-wrap">
                              {product.variants.map((variant, index) => (
                                <button 
                                  key={index} onClick={() => setSelectedVariant(index)}
                                  className={`text-xs px-2 py-1 rounded-md transition-colors ${
                                    selectedVariant === index ? 'bg-[#606c38] text-white' : 'bg-gray-100 hover:bg-[#606c38] hover:text-white'
                                  }`}
                                >
                                  {variant}
                                </button>
                              ))}
                            </div>
                          </div>

                          {/* Actions */}
                          <div className="flex gap-2 mt-auto">
                            <Button size="sm" className="flex-1 bg-[#606c38] hover:bg-[#606c38]/90 text-white rounded-lg"
                              onClick={() => handleAddToCart(product, selectedVariant)}
                            >
                              <ShoppingCart className="h-4 w-4 mr-2" />
                              Agregar
                            </Button>
                            <Button size="sm" variant="outline" 
                              className="border-[#606c38]/30 text-[#606c38] hover:bg-[#606c38] rounded-lg"
                              onClick={() => {
                                const currentId = Array.isArray(product.id) ? product.id[selectedVariant] : product.id;
                                navigate(`/products/${currentId}`)
                                window.scrollTo(0, 0)
                              }}
                            >
                              Detalle
                            </Button>
                          </div>
                        </div>
                      </div>
                    </div>
                  );
                };

                return (
                  <SwiperSlide key={product.id}>
                    <ProductCard />
                  </SwiperSlide>
                );
              })}
            </Swiper>
            <p className="text-md text-center font-semibold text-[#606c38]">Desliza para ver más modelos</p>
          </div>
        </section>
        
        {/* Categorias */}
        <section className="py-8">
          <div className="container">
            <h2 className="text-4xl lg:text-5xl font-light tracking-tight text-center text-gray-900 mb-12">
              Colecciones Históricas
            </h2>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6">
              {categoriesData.map((category, index) => (
                <EnhancedLegacyCard
                  key={index}
                  image={category.image}
                  title={category.title}
                  description={category.description}
                  category={category.category}
                  itemCount={category.itemCount}
                  trending={category.trending}
                  onClick={handleCategoryClick}
                />
              ))}
            </div>
          </div>
        </section>

        {/* Beneficios */}
        <section className="py-16 bg-[#dda15e]/10">
          <div className="container">
            <h2 className="text-4xl lg:text-5xl font-light tracking-tight text-center text-gray-900 mb-12">¿Por qué elegir Archivo Deportivo?</h2>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
              <div className="bg-white rounded-lg shadow-lg overflow-hidden transform transition-transform hover:-translate-y-2 duration-300">
                <div className="bg-[#606c38]/10 p-6 flex justify-center">
                  <div className="bg-white rounded-full p-4 shadow-md">
                    <Shirt className="h-10 w-10 text-[#606c38]" />
                  </div>
                </div>
                <div className="p-6 text-center">
                  <h3 className="text-xl font-bold mb-3 text-[#606c38]">+8000 Modelos Únicos</h3>
                  <p className="text-gray-600">
                    La colección más amplia de camisetas de fútbol en el país, desde clásicos históricos hasta los últimos lanzamientos.
                  </p>
                  <div className="mt-4 pt-4 border-t border-gray-100">
                    <Link href="#" className="text-[#606c38] font-medium hover:underline inline-flex items-center">
                      Ver catálogo completo
                      <ChevronRight className="ml-1 h-4 w-4" />
                    </Link>
                  </div>
                </div>
              </div>

              <div className="bg-white rounded-lg shadow-lg overflow-hidden transform transition-transform hover:-translate-y-2 duration-300">
                <div className="bg-[#606c38]/10 p-6 flex justify-center">
                  <div className="bg-white rounded-full p-4 shadow-md">
                    <Award className="h-10 w-10 text-[#606c38]" />
                  </div>
                </div>
                <div className="p-6 text-center">
                  <h3 className="text-xl font-bold mb-3 text-[#606c38]">Personalización Total</h3>
                  <p className="text-gray-600">
                    Agregá nombre, número y parches oficiales a tu camiseta. Hacela única y representá a tu ídolo favorito.
                  </p>
                  <div className="mt-4 pt-4 border-t border-gray-100">
                    <Link href="#" className="text-[#606c38] font-medium hover:underline inline-flex items-center">
                      Opciones de personalización
                      <ChevronRight className="ml-1 h-4 w-4" />
                    </Link>
                  </div>
                </div>
              </div>

              <div className="bg-white rounded-lg shadow-lg overflow-hidden transform transition-transform hover:-translate-y-2 duration-300">
                <div className="bg-[#606c38]/10 p-6 flex justify-center">
                  <div className="bg-white rounded-full p-4 shadow-md">
                    <Truck className="h-10 w-10 text-[#606c38]" />
                  </div>
                </div>
                <div className="p-6 text-center">
                  <h3 className="text-xl font-bold mb-3 text-[#606c38]">Envíos a Todo el País</h3>
                  <p className="text-gray-600">
                    Recibí tu camiseta en la puerta de tu casa. Seguimiento, atencion personalizada las 24hs y garantía de entrega.
                  </p>
                  <div className="mt-4 pt-4 border-t border-gray-100">
                    <Link href="#" className="text-[#606c38] font-medium hover:underline inline-flex items-center">
                      Políticas de envío
                      <ChevronRight className="ml-1 h-4 w-4" />
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Estadísticas */}
        <section className="py-12 bg-gradient-to-br from-[#fefae0]/30 via-white to-[#606c38]/5">
          <h2 className="text-4xl lg:text-5xl font-light tracking-tight text-center text-gray-900 mb-12">Nuestros Clientes</h2>
          <div className="container mb-12">
            <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
              <div className="text-center">
                <div className="bg-white rounded-xl shadow-md p-6 border border-[#606c38]/10 hover:shadow-lg transition-shadow">
                  <div className="text-3xl md:text-4xl font-bold text-[#606c38] mb-2">+250</div>
                  <div className="text-sm md:text-base text-gray-600 font-medium">Camisetas vendidas</div>
                </div>
              </div>
              <div className="text-center">
                <div className="bg-white rounded-xl shadow-md p-6 border border-[#606c38]/10 hover:shadow-lg transition-shadow">
                  <div className="text-3xl md:text-4xl font-bold text-[#606c38] mb-2">+70</div>
                  <div className="text-sm md:text-base text-gray-600 font-medium">Clientes satisfechos</div>
                </div>
              </div>
              <div className="text-center">
                <div className="bg-white rounded-xl shadow-md p-6 border border-[#606c38]/10 hover:shadow-lg transition-shadow">
                  <div className="text-3xl md:text-4xl font-bold text-[#606c38] mb-2">100%</div>
                  <div className="text-sm md:text-base text-gray-600 font-medium">Reseñas positivas</div>
                </div>
              </div>
              <div className="text-center">
                <div className="bg-white rounded-xl shadow-md p-6 border border-[#606c38]/10 hover:shadow-lg transition-shadow">
                  <div className="text-3xl md:text-4xl font-bold text-[#606c38] mb-2">5★</div>
                  <div className="text-sm md:text-base text-gray-600 font-medium">Calificación promedio</div>
                </div>
              </div>
            </div>
          </div>
          {/* Testimonios */}
          <div className="container">
            <Swiper modules={[Pagination]} pagination={{ clickable: true, }} className="!pb-12" spaceBetween={24} slidesPerView={1}
             breakpoints={{ 768: { slidesPerView: 2, }, 1024: { slidesPerView: 3, }, }} >
              <SwiperSlide> <TestimonialCard quote="La del Milan 2007 que compré es una joya. Me trajo recuerdos del golazo de Kaká. Impecable todo." author="Facundo L." location="Bahía Blanca" rating={5} /> </SwiperSlide>
              <SwiperSlide> <TestimonialCard quote="Ya es la tercera vez que compro y siempre todo de diez. Buen trato, buena calidad y variedad." author="Bruno R." location="San Nicolás" rating={5} /> </SwiperSlide>
              <SwiperSlide> <TestimonialCard quote="La del Arsenal de Bergkamp llegó impecable, bien cuidada y con olor a nuevo. Tremenda." author="Nahuel D." location="Lanús" rating={5} /> </SwiperSlide>
              <SwiperSlide> <TestimonialCard quote="Muy buena atención por WhatsApp. Me ayudaron con el talle y el envío llegó justo para el cumple de mi hermano." author="Julieta M." location="Córdoba" rating={5} /> </SwiperSlide>
              <SwiperSlide> <TestimonialCard quote="Pintó la del Ajax ‘95 con Litmanen y no me pude resistir. Está increíble, re bien lograda." author="Gustavo A." location="Salta" rating={5} /> </SwiperSlide>
              <SwiperSlide> <TestimonialCard quote="Todo ok." author="Lautaro F." location="Quilmes" rating={5} /> </SwiperSlide>
              <SwiperSlide> <TestimonialCard quote="Me gustó mucho que no son los modelos típicos. Conseguí la de Gremio del 98 que no encontraba en ningún lado." author="Santiago P." location="Paraná" rating={5} /> </SwiperSlide>
              <SwiperSlide> <TestimonialCard quote="La tela es buenísima, se nota apenas la sacás del paquete. Sin dudas voy a seguir comprando." author="Martin G." location="La Plata" rating={5} /> </SwiperSlide>
              <SwiperSlide> <TestimonialCard quote="Pedí una del Real con el nombre de mi nene y quedó pintada. Se la pone para dormir incluso, jaja." author="Camilo S." location="Rosario" rating={5} /> </SwiperSlide>
              <SwiperSlide> <TestimonialCard quote="La atención es de primera. Me escribieron al toque para confirmar el envío y me mandaron número de seguimiento con todos los detalles." author="Florencia J." location="Neuquén" rating={5} /> </SwiperSlide>
              <SwiperSlide> <TestimonialCard quote="La del Inter con Zanetti es una locura. No la veía hace años, y acá la tienen como nueva." author="Ezequiel B." location="Mendoza" rating={5} /> </SwiperSlide>
              <SwiperSlide> <TestimonialCard quote="El talle vino medio justo, pero la camiseta está buenísima. Me la quedo igual porque me encanta." author="Lucas V." location="San Juan" rating={4} /> </SwiperSlide> 
            </Swiper>
            <p className="text-md text-center font-semibold text-[#606c38]">Desliza para ver más reseñas</p>
          </div>
        </section>

        {/* CTA Final */}
        <section className="py-20 bg-[#606c38] text-white">
          <div className="container text-center">
            <h2 className="text-3xl md:text-4xl font-bold tracking-tight mb-4">Descubrí tu camiseta soñada</h2>
            <p className="max-w-2xl mx-auto mb-8 text-[#fefae0]/90">
              Más de 8000 modelos te esperan. Vestí la historia del fútbol con Archivo Deportivo.
            </p>
            <Button size="lg" className="bg-[#283618] text-[#606c38]/80 hover:bg-white/20 border-2 border-[#fefae0]/90 "
            onClick={() => {
                  navigate(`/products`)
                  window.scrollTo(0, 0)
                }}>
              Explorá el catálogo completo
              <ChevronRight className="ml-2 h-4 w-4" />
            </Button>
          </div>
        </section>
      </main>

      {/* Footer */}
      {/* <footer className="bg-[#283618] text-white py-12">
        <div className="container">
          <div className="grid grid-cols-1 md:grid-cols-5 gap-8">
            <div>
              <Link href="/" className="flex items-center gap-2 mb-4">
                <img
                  src={image2}
                  alt="Archivo Deportivo Logo"
                  width={40}
                  height={40}
                  className="rounded-md"
                />
                <span className="text-xl font-semibold tracking-tight">Archivo Deportivo</span>
              </Link>
              <p className="text-[#fefae0]/80 text-sm">
                El legado del deporte, en tus manos.
              </p>
              <p className="text-[#fefae0]/80 text-sm">
                La mayor colección de camisetas de fútbol de Argentina.
              </p>
            </div>
            <div>
              <h3 className="font-medium text-lg mb-4">Navegación</h3>
              <ul className="space-y-2 text-[#fefae0]/80">
                <li>
                  <Link href="#" className="hover:text-white transition-colors">
                    Inicio
                  </Link>
                </li>
                <li>
                  <Link href="#" className="hover:text-white transition-colors">
                    Catalogo
                  </Link>
                </li>
                <li>
                  <Link href="#" className="hover:text-white transition-colors">
                    Iconos
                  </Link>
                </li>
              </ul>
            </div>
            <div>
              <h3 className="font-medium text-lg mb-4">Competiciones</h3>
              <ul className="space-y-2 text-[#fefae0]/80">
                <li>
                  <Link href="#" className="hover:text-white transition-colors">
                    Ballon d'or
                  </Link>
                </li>
                <li>
                  <Link href="#" className="hover:text-white transition-colors">
                    Champions
                  </Link>
                </li>
                <li>
                  <Link href="#" className="hover:text-white transition-colors">
                    Mundial
                  </Link>
                </li>
              </ul>
            </div>
            <div>
              <h3 className="font-medium text-lg mb-4">Información</h3>
              <ul className="space-y-2 text-[#fefae0]/80">
                <li>
                  <Link href="#" className="hover:text-white transition-colors">
                    Envíos
                  </Link>
                </li>
                <li>
                  <Link href="#" className="hover:text-white transition-colors">
                    Devoluciones
                  </Link>
                </li>
                <li>
                  <Link href="#" className="hover:text-white transition-colors">
                    Medios de pago
                  </Link>
                </li>
                <li>
                  <Link href="#" className="hover:text-white transition-colors">
                    Preguntas frecuentes
                  </Link>
                </li>
                <li>
                  <Link href="#" className="hover:text-white transition-colors">
                    Términos y condiciones
                  </Link>
                </li>
              </ul>
            </div>
            <div>
              <h3 className="font-medium text-lg mb-4">Contacto</h3>
              <ul className="space-y-2 text-[#fefae0]/80">
                <li>contacto.archivodeportivo@gmail.com</li>
                <li>+549 342 4365585</li>
                <li>Santa Fe, Argentina</li>
              </ul>
              <div className="flex gap-4 mt-4">
                <Link href="#" className="text-white hover:text-[#dda15e] transition-colors">
                  <span className="sr-only">Instagram</span>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="h-5 w-5"
                  >
                    <rect width="20" height="20" x="2" y="2" rx="5" ry="5"></rect>
                    <path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z"></path>
                    <line x1="17.5" x2="17.51" y1="6.5" y2="6.5"></line>
                  </svg>
                </Link>
                <Link href="#" className="text-white hover:text-[#dda15e] transition-colors">
                  <span className="sr-only">Facebook</span>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="h-5 w-5"
                  >
                    <path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z"></path>
                  </svg>
                </Link>
                <Link href="#" className="text-white hover:text-[#dda15e] transition-colors">
                  <span className="sr-only">Twitter</span>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="h-5 w-5"
                  >
                    <path d="M22 4s-.7 2.1-2 3.4c1.6 10-9.4 17.3-18 11.6 2.2.1 4.4-.6 6-2C3 15.5.5 9.6 3 5c2.2 2.6 5.6 4.1 9 4-.9-4.2 4-6.6 7-3.8 1.1 0 3-1.2 3-1.2z"></path>
                  </svg>
                </Link>
              </div>
            </div>
          </div>
          <div className="border-t border-[#fefae0]/20 mt-8 pt-8 text-center text-[#fefae0]/60 text-sm">
            <p>© {new Date().getFullYear()} Archivo Deportivo. Todos los derechos reservados.</p>
          </div>
        </div>
      </footer> */}
    </div>
  )
}